<template>

</template>


<script>
export default {
  name: "FilterMenu"
};
</script>



<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/FilterMenu.vue